import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import VouchersQuery from '@/plugins/graphql/queries/v2/store_add_ons/vouchers-by-uuids.gql';
import ActionButton from '@/components/action_button/Index.vue';
import { VoucherRebateModel } from '@/helpers/entities/models/VoucherRebateModel';
import RedeemVoucherDialog from '@/components/v2/store_add_ons/RedeemVoucherDialog.vue';
import RedeemVoucherKyc from '@/components/v2/store_add_ons/RedeemVoucherKyc.vue';
import BaseText from '@/components/BaseText.vue';
import { noteMessage } from '@/helpers/mixins/LocalizationHelper';
let RedeemVoucherPage = class RedeemVoucherPage extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.totalCount = 0;
        this.noteMessage = noteMessage();
    }
    pageTitle(totalCount) {
        return `Redeem Vouchers ${totalCount}`;
    }
    get headers() {
        return [
            {
                text: 'VOUCHER CODE',
                value: 'serialId',
                align: 'left',
                sortable: false,
            },
            {
                text: 'CUSTOMER',
                value: 'customerdetail.customerFullName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DATE APPROVED',
                value: 'formattedCreatedAt',
                align: 'left',
                sortable: false,
            },
            {
                text: 'VOUCHERS AMOUNT',
                value: 'amount',
                align: 'left',
                sortable: false,
            },
        ];
    }
    get disableAddMoreButton() {
        return this.storeVouchers.length >= 3;
    }
};
__decorate([
    Getter('vouchers', { namespace: 'vouchers' })
], RedeemVoucherPage.prototype, "storeVouchers", void 0);
RedeemVoucherPage = __decorate([
    Component({
        components: {
            ActionButton,
            RedeemVoucherDialog,
            RedeemVoucherKyc,
            BaseText,
        },
        apollo: {
            fetchVouchers: {
                query: VouchersQuery,
                variables() {
                    return {
                        voucherUuids: this.storeVouchers,
                    };
                },
                update(data) {
                    const vouchers = data.vouchers.edges;
                    const voucherNodes = (voucher) => {
                        return new VoucherRebateModel(voucher.node);
                    };
                    this.totalCount = data.vouchers.totalCount;
                    return vouchers.map(voucherNodes);
                },
            },
        },
    })
], RedeemVoucherPage);
export default RedeemVoucherPage;
